import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { requestForwardDrawInfo } from "@services/administrativeApprovals";

export const useRequestForwardDrawInfo = (
  options: Record<string, any> = {}
) => {
  const { onSuccess, ...restOptions } = options;
  const queryClient = useQueryClient();

  return useMutation(requestForwardDrawInfo, {
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ["administrativeApprovals"],
      });

      if (isFunction(onSuccess)) {
        onSuccess(res);
      }
    },
    ...restOptions,
  });
};
